import Service from './baseService';
import { getModelTypeIdAndEntityId } from '../config';

export const getContactsService = () => {
    return Service.get(`/customer/contacts`, { params: { ...getModelTypeIdAndEntityId() } });
};

export const editContactDetailsService = (data, contactId) => {
    return Service.put(`/customer/contacts/${contactId}`, data, { params: { ...getModelTypeIdAndEntityId() } });
};
